import HARDCODE from '../../business-const/HardCode/HardCode'



const formTypeList = [
    {
        id: HARDCODE.formTypeReceitaMensal,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaReceitaMensal,
        ordem: 10,
    },
    {
        id: HARDCODE.formTypeDiaDia,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaDiaDia,
        ordem: 20,
    },
    {
        id: HARDCODE.formTypeEducacao,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaEducacao,
        ordem: 30,
    },
    {
        id: HARDCODE.formTypeFinanciamento,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaFinanciamento,
        ordem: 40,
    },
    {
        id: HARDCODE.formTypeFinanciamento,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaFinanciamento,
        ordem: 50,
    },
    {
        id: HARDCODE.formTypeProjetoVidaSonho,
        stepsValor: 'stepsValorFluxoCaixa',
        indexStepsValor: HARDCODE.indexFluxoCaixaProjetoVidaSonho,
        ordem: 60,
    },
    {
        id: HARDCODE.formTypePatrimonioImobilizado,
        stepsValor: 'stepsValorPatrimonio',
        indexStepsValor: HARDCODE.indexPatrimonioPatrimonioImobilizado,
        ordem: 70,
    },
    {
        id: HARDCODE.formTypeRecursosFinanceiros,
        stepsValor: 'stepsValorPatrimonio',
        indexStepsValor: HARDCODE.indexPatrimonioRecursosFinanceiros,
        ordem: 80,
    },
]

export default formTypeList